import { Injectable } from '@angular/core';
import { BaseHttpService } from '@shared/services/base-http.service';
import { Observable } from 'rxjs';
import { Response } from '@shared/models/response.model';
import { map } from 'rxjs/operators';
import { Notification } from '@shared/models/notification.model';
import { NotificationStatistics } from '@shared/interfaces/notification-statistics.interface';

@Injectable({
  providedIn: 'root',
})
export class NotificationsDropdownService {
  constructor(public baseHttp: BaseHttpService) {}

  getNotifications(): Observable<Response<Notification>> {
    return this.baseHttp.get('/notification').pipe(map((resp) => resp as Response<Notification>));
  }

  getNotificationsStatistics(): Observable<Response<NotificationStatistics>> {
    return this.baseHttp
      .get('/notification/statistics')
      .pipe(map((resp) => resp as Response<NotificationStatistics>));
  }

  markAsRead(id: number): Observable<Response<Notification>> {
    return this.baseHttp
      .post('/notification/mark-as-seen/' + id, {})
      .pipe(map((resp) => resp as Response<Notification>));
  }

  clearAllNotifications(): Observable<Response<Notification>> {
    return this.baseHttp
      .post('/notification/clear-all', {})
      .pipe(map((resp) => resp as Response<Notification>));
  }
}
